import { fetcher } from '@commenda/utils';

export const runBillingRenewalTest = async (quoteId: string) =>
  fetcher(`commenda-billing/quotes/${quoteId}/renewal-runs`, {
    method: 'POST',
  });
